export default __webpack_public_path__ + "static/media/schedule_app_calender_image.63994a57.png";